import { Component } from '@angular/core';

@Component({
  selector: 'tun-queue-full-icon-v5',
  templateUrl: './queue-full-icon-v5.component.html',
  styleUrls: ['./queue-full-icon-v5.component.scss']
})
export class QueueFullIconV5Component {

}
